import api from '../api';

export const uploadEvidenceFile = ({ file, responseId, responseType, onUploadProgress, signal }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('response_id', String(responseId));
  formData.append('response_type', responseType); // 'cobit' | 'bcm'

  return api.post('maturity/upload-evidence-file/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
    signal,
  });
};

export const removeEvidenceFile = ({ responseId, responseType, fileId }) => {
  return api.delete(`maturity/evidence-files/${responseId}/${responseType}/${fileId}/remove/`);
};